module.exports = __webpack_public_path__ + "static/img/contextedlogo.c9db1f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contextedlogo.png
// module id = qoZw
// module chunks = 1